import { html, css, LitElement } from 'lit';
import { Text } from '../Text/Text';
import { Image } from '../Image/Image';

class GroupInfo extends LitElement {
  static properties = {
    imageSrc: { type: String },
    imageAlt: { type: String },
    imageHeight: { type: String },
    imageWidth: { type: String },
    imageRadius: { type: String },
    //    image property ends here
    label: { type: String },
    labelColor: { type: String },
    labelFontFamily: { type: String },
    labelFontWeight: { type: String },
    labelFontSize: { type: String },
    labelFontStyle: { type: String },
    //    label properties ends here

    padding: { type: String },
    bgColor: { type: String },
    borderWidth: { type: String },
    borderColor: { type: String },
    borderStyle: { type: String },
    height: { type: String },
    width: { type: String },
    textColor: { type: String },
    groupTitle: { type: String },
    selectedUserIds: { type: Array },
    closeGroupInfo: { type: Function },
    isGroupCast: {type: Boolean}
  };

  static styles = css`
    .chip-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .chip-close-icon {
      cursor: pointer;
      flex-shrink: 0;
    }
    .chip-label-container {
      overflow-wrap: break-word;
      word-wrap: break-word;
      word-break: break-word;
      max-width: calc(100% - 40px);
      margin: 0 8px;
    }
    .chip-image-container {
      flex-shrink: 0;
    }

    .group-info-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;
      padding: 20px;
    }

    .group-info-image {
      position: relative;
      width: 200px;
      height: 200px;
      border-radius: 50%;
      overflow: hidden;
      background-color: rgba(0, 0, 0, 0.2);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 2px dashed #ccc;
      transition: border-color 0.3s ease;
    }

    .group-info-image:hover {
      border-color: #666;
    }

    .default-group-svg {
      position: absolute;
      width: 60%;
      height: 60%;
      opacity: 0.3;
      top: 20%;
    }

    .image-upload-label {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-color: #f5f5f5;
      border-radius: 50%;
      font-size: 14px;
      font-weight: 500;
      color: #666;
      cursor: pointer;
      text-align: center;
      z-index: 1;
      transition: background-color 0.3s ease;
    }

    .image-upload-label:hover {
      background-color: #eeeeee;
    }

    .image-upload-input {
      display: none;
    }

    .preview-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .preview-image-container {
      position: relative;
      width: 100%;
      height: 100%;
    }

    .edit-overlay {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: rgba(0, 0, 0, 0.5);
      border-radius: 50%;
      padding: 8px;
      cursor: pointer;
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    .preview-image-container:hover .edit-overlay {
      opacity: 1;
    }

    .edit-icon {
      width: 24px;
      height: 24px;
      color: white;
    }

    .image-upload-input {
      display: none;
    }

    .image-controls {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      gap: 8px;
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    .preview-image-container:hover .image-controls {
      opacity: 1;
    }

    .control-button {
      background-color: rgba(0, 0, 0, 0.5);
      border-radius: 50%;
      padding: 8px;
      cursor: pointer;
      color: white;
    }

    .control-button:hover {
      background-color: rgba(0, 0, 0, 0.7);
    }

    .group-info-title input {
      padding: 8px 12px;
      font-size: 16px;
      width: 100%;
      border: none;
      background-color: transparent;
    }

    .group-info-title input:focus {
      outline: none;
      border-color: #666;
    }

    .group-info-topbar {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 10px;
    }

    .group-info-topbar svg {
      cursor: pointer;
    }
      
    .create-group-button button {
      padding: 12px 24px;
      font-size: 16px;
      background-color: var(--text-primary-color);
      color: var(--bg-primary-color);
      border: none;
      border-radius: 8px;
      cursor: pointer;
      transition: background-color 0.3s ease;
      font-weight: 500;
      min-width: 160px;
    }

    .create-group-button button:active {
      transform: scale(0.98);
      background-color: var(--text-primary-color);
    }

    .create-group-button button:disabled {
      background-color: #cccccc;
      cursor: not-allowed;
    }

    .camera-icon {
      width: 48px;
      height: 48px;
      margin-bottom: 12px;
    }

    .upload-text {
      margin-top: 8px;
      text-align: center;
      line-height: 1.4;
    }
  `;

  constructor() {
    super();
    this.profilePlaceholderImage = 'https://isometrik-website-bucket.s3.ap-south-1.amazonaws.com/Frame_02577f7cb1.svg';
    this.groupTitle = '';
    this.selectedUserIds = [];
    this.isGroupCast = false;
  }

  handleImageError(e) {
    e.target.src = this.profilePlaceholderImage;
  }

  handleGroupTitleChange(e) {
    this.groupTitle = e.target.value;
  }

  handleCreateGroup() {
    if (!this.groupTitle.trim()) {
      return;
    }

    const groupDetails = {
      conversationTitle: this.groupTitle,
      imageFile: this.imageFile ,
      selectedUserIds: this.selectedUserIds
    };
    const eventName = this.isGroupCast ? 'create-group-cast-submitted' : 'create-group-submitted'

    // Dispatch event with all group details
    this.dispatchEvent(new CustomEvent(eventName, {
      detail: {
        ...groupDetails,
        closeAll: true,
        isGroupCast: this.isGroupCast
      },
      bubbles: true,
      composed: true
    }));

    // Close the group info overlay
    if (this.closeGroupInfo) {
      this.closeGroupInfo();
    }
  }

  render() {
    return html`
      <div class="group-info-container" style="background-color: ${this.bgColor}; width: ${this.width}; height: ${this.height}; padding: ${this.padding};">
        <div class="group-info-topbar">
          <svg @click=${this.closeGroupInfo} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="${this.textColor}">
            <path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z" />
          </svg>
          ${Text({
            content: this.label,
            fontSize: this.labelFontSize,
            fontFamily: this.labelFontFamily,
            color: this.textColor,
          })}
        </div>
        <div class="group-info-content">
          <div class="group-info-image">
            ${this.imageSrc
              ? html`
                  <div class="preview-image-container">
                    <img class="preview-image" src="${this.imageSrc}" alt="Group photo" @error=${this.handleImageError} />
                    <div class="image-controls">
                      <div class="control-button" @click=${this._triggerFileInput}>
                        <svg class="edit-icon" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="currentColor">
                          <path
                            d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                          />
                        </svg>
                      </div>
                      <div class="control-button" @click=${this._removeImage}>
                        <svg class="edit-icon" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="currentColor">
                          <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
                        </svg>
                      </div>
                    </div>
                    <input type="file" class="image-upload-input" accept="image/*" @change=${this._handleImageUpload} id="fileInput" />
                  </div>
                `
              : html`
                  <label class="image-upload-label">
                    <svg class="default-group-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                      <path
                        d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zM20 19h-6v-2.5c0-2.33 4.67-3.5 7-3.5V19z"
                      />
                    </svg>
                    <svg class="camera-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#666">
                      <path
                        d="M440-440ZM120-120q-33 0-56.5-23.5T40-200v-480q0-33 23.5-56.5T120-760h126l74-80h240v80H355l-73 80H120v480h640v-360h80v360q0 33-23.5 56.5T760-120H120Zm640-560v-80h-80v-80h80v-80h80v80h80v80h-80v80h-80ZM440-260q75 0 127.5-52.5T620-440q0-75-52.5-127.5T440-620q-75 0-127.5 52.5T260-440q0 75 52.5 127.5T440-260Zm0-80q-42 0-71-29t-29-71q0-42 29-71t71-29q42 0 71 29t29 71q0 42-29 71t-71 29Z"
                      />
                    </svg>
                    <div class="upload-text">
                      Add Group<br>Photo
                    </div>
                    <input type="file" class="image-upload-input" accept="image/*" @change=${this._handleImageUpload} />
                  </label>
                `}
          </div>
          <div class="group-info-title" style="border-bottom: 1px solid var(--text-primary-color); width: 100%;">
            <input 
              type="text" 
              placeholder="${this.isGroupCast? 'Groupcast Name' : 'Group Name'}" 
              style="color: ${this.textColor};"
              .value=${this.groupTitle}
              @input=${this.handleGroupTitleChange}
            />
          </div>
          <div class="create-group-button">
            <button 
              @click=${this.handleCreateGroup}  
              ?disabled=${!this.groupTitle.trim() }
            >
              Create Group
            </button>
          </div>
        </div>
      </div>
    `;
  }

  _handleImageUpload(e) {
    const file = e.target.files[0];
    if (file) {
      this.imageFile = file;
      
      const reader = new FileReader();
      reader.onload = e => {
        this.imageSrc = e.target.result;
        this.requestUpdate();
      };
      reader.readAsDataURL(file);
    }
  }

  _triggerFileInput() {
    this.shadowRoot.querySelector('#fileInput').click();
  }

  _removeImage() {
    this.imageSrc = '';
    this.imageFile = null;
    this.requestUpdate();
  }
}

customElements.define('iso-group-info', GroupInfo);
